import { template } from "@ember/template-compiler";
import { CONSENT_CATEGORIES, analyticsEnabled, parseDataGrailCookie, preferencesToCookieOptions } from '../utils/datagrail';
import { service } from '@ember/service';
import Component from '@glimmer/component';
export default class DgConsentCallbacks extends Component {
    @service
    currentPractice;
    @service
    session;
    @service
    store;
    constructor(){
        super(...arguments);
        this.initDatagrail();
    }
    checkForConsent(preferences1) {
        if (window.mixpanel && !analyticsEnabled(preferences1)) {
            window.mixpanel.reset();
        }
    }
    initDatagrail = ()=>{
        if (typeof window === 'undefined') return;
        window.dgEvent ??= [];
        window.dgEvent.push({
            event: 'preference_callback',
            params: this.onPreferenceCallback
        });
        window.dgEvent.push({
            event: 'initial_preference_callback',
            params: this.currentPractice.get('featureDatagrailSegmentConsentClients') ? this.syncConsentPreferences : this.checkForConsent
        });
    };
    syncConsentPreferences = async ()=>{
        if (!this.session.currentClient) return;
        let pref1;
        try {
            pref1 = await this.store.queryRecord('tracking-consent-preference', {});
        } catch  {
            return;
        }
        const cookiePrefs1 = parseDataGrailCookie();
        const effective1 = cookiePrefs1 ? CONSENT_CATEGORIES.reduce((acc1, { dbKey: dbKey1, cookieKey: cookieKey1 })=>{
            acc1[dbKey1] = pref1[dbKey1] && (cookiePrefs1[cookieKey1] ?? true);
            return acc1;
        }, {}) : pref1;
        const needsSync1 = cookiePrefs1 && CONSENT_CATEGORIES.some(({ dbKey: dbKey1 })=>effective1[dbKey1] !== pref1[dbKey1]);
        if (needsSync1) {
            this.store.adapterFor('tracking-consent-preference').update(effective1);
        }
        const preferences1 = preferencesToCookieOptions(effective1);
        const cookieMatchesEffective1 = cookiePrefs1 && CONSENT_CATEGORIES.every(({ dbKey: dbKey1, cookieKey: cookieKey1 })=>effective1[dbKey1] === cookiePrefs1[cookieKey1]);
        if (!cookieMatchesEffective1) {
            window.DG_BANNER_API?.setConsentPreferences(preferences1, {
                runPreferenceCallbacks: false
            });
        }
        this.checkForConsent({
            consentPreferences: preferences1
        });
    };
    onPreferenceCallback = (preferences1)=>{
        this.checkForConsent(preferences1);
        if (!this.session.currentClient) return;
        if (!this.currentPractice.get('featureDatagrailSegmentConsentClients')) return;
        const { cookieOptions: cookieOptions1 } = preferences1.consentPreferences;
        this.store.adapterFor('tracking-consent-preference').update(CONSENT_CATEGORIES.reduce((acc1, { dbKey: dbKey1, cookieKey: cookieKey1 })=>{
            acc1[dbKey1] = cookieOptions1.find((o1)=>o1.gtm_key === cookieKey1)?.isEnabled ?? true;
            return acc1;
        }, {}));
    };
    static{
        template(`
    {{! intentionally renders nothing; this component exists to initialize DataGrail callbacks }}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
